export enum JOB_MODULE_SUBJECT_TYPES {
  INTERVENTION = "intervention",
  LOCATION = "location",
  PROJECT = "project",
}
